import { Icon } from '@wtfalch/design';

/**
 * Glyphs the design canvas draws that `@wtfalch/design`'s `Icon` does not
 * carry (`archive` is kept in `mail/icons.tsx` since only Mail draws it). Drawn to the same stroke
 * weight as the design canvas's own thin-line icons (the ones the canvas's
 * generator calls its `STROKE` set, as against Pepicons' filled ones, which
 * `Icon` already renders), so they sit unremarked beside the rest.
 *
 * `Stroke` itself is exported: Chat needs its own glyphs the same way
 * (`chat/icons.tsx`'s `HashIcon`), on the same weight, without a second
 * copy of this wrapper.
 */
export function Stroke({ d, size = 18 }: { d: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export function FilterIcon({ size }: { size?: number }) {
  return <Icon name="filter" size={size ?? 18} />;
}
